<template>
  <div id="home" class="mt-5 mx-auto">
    <div class="row">
      <how-many v-for="item in firstLine"
                :key="item.title"
                :title="item.title"
                :value="item.value"
                :max="item.max"
                :list-route-path="item.listRoutePath"
                :add-route-path="isRole.admin ? item.addRoutePath : ''"
                :background-icon="item.icon"
                class="col"
      />
    </div>

    <div class="row mt-5">
      <how-many v-for="item in secondLine"
                :key="item.title"
                :title="item.title"
                :value="item.value"
                :max="item.max"
                :list-route-path="item.listRoutePath"
                :add-route-path="isRole.admin ? item.addRoutePath : ''"
                :background-icon="item.icon"
                class="col-4"
      />
    </div>

    <div class="row mt-3">
      <div v-for="(item, i) in lastViewed" :key="'last-viewed-' + i" class="col-4">
        <last-viewed :empty-message="item.emptyMessage" :list="item.list" />
      </div>
    </div>
  </div>
</template>

<script>
import HowMany from './HowMany.vue'
import LastViewed from './LastViewed.vue'

export default {
  titleKey: 'home',

  components: { HowMany, LastViewed },

  data () {
    return {
      nbFleets: '-',
      nbGateways: '-',
      nbCustomers: '-',
      nbUsers: '-',
      nbClusters: '-',
      nbEndDevices: '-',
      nbGroups: '-'
    }
  },

  computed: {
    firstLine () {
      const firstLine = [{
        title: this.$t('home:fleets'),
        value: this.nbFleets,
        listRoutePath: 'fleets',
        addRoutePath: 'administration/fleets',
        icon: 'icon-fleet'
      }, {
        title: this.$t('home:clusters'),
        value: this.nbClusters,
        listRoutePath: 'clusters',
        addRoutePath: 'administration/clusters',
        icon: 'icon-cluster'
      }]

      if (this.isRole.superAdmin) {
        firstLine.push({
          title: this.$t('home:customers'),
          value: this.nbCustomers,
          addRoutePath: 'administration/customers',
          icon: 'icon-user'
        })
      }

      firstLine.push({
        title: this.$t('home:users'),
        value: this.nbUsers,
        max: this.isRole.superAdmin ? this.$store.getters.application.license.maxUsers : this.$store.getters.authenticatedUserCustomer.maxUsers,
        addRoutePath: 'administration/users',
        icon: 'icon-user'
      })
      return firstLine
    },

    secondLine () {
      return [{
        title: this.$t('home:gateways'),
        value: this.nbGateways,
        max: this.isRole.superAdmin ? this.$store.getters.application.license.maxGateways : this.$store.getters.authenticatedUserCustomer.maxGateways,
        listRoutePath: 'gateways',
        addRoutePath: 'administration/gateways',
        icon: 'icon-gateway'
      }, {
        title: this.$t('home:endDevices'),
        value: this.nbEndDevices,
        max: this.isRole.superAdmin ? this.$store.getters.application.license.maxEndDevices : this.$store.getters.authenticatedUserCustomer.maxEndDevices,
        listRoutePath: 'end-devices',
        addRoutePath: 'administration/end-devices',
        icon: 'icon-end-device'
      }, {
        title: this.$t('home:multicastGroups'),
        value: this.nbGroups,
        listRoutePath: 'multicast-groups',
        addRoutePath: 'administration/multicast-groups',
        icon: 'icon-cluster'
      }]
    },

    lastViewed () {
      return [{
        emptyMessage: this.$t('home:noGatewaysViewed'),
        list: this.$store.getters.lastViewedGateways
      }, {
        emptyMessage: this.$t('home:noEndDevicesViewed'),
        list: this.$store.getters.lastViewedEndDevices
      }, {
        emptyMessage: this.$t('home:noMulticastGroupsViewed'),
        list: this.$store.getters.lastViewedMulticastGroups
      }]
    }
  },

  created () {
    this.getStats()
  },

  methods: {
    getStats () {
      this.$api.getStats(this.$store.getters.application)
        .then(r => {
          this.nbFleets = r.data ? r.data.nbFleets || '-' : '-'
          this.nbGateways = r.data ? r.data.nbGateways || '-' : '-'
          this.nbUsers = r.data ? r.data.nbUsers || '-' : '-'
          this.nbClusters = r.data ? r.data.nbClusters || '-' : '-'
          this.nbEndDevices = r.data ? r.data.nbEndDevices || '-' : '-'
          this.nbGroups = r.data ? r.data.nbMulticastGroups || '-' : '-'
          this.nbCustomers = r.data ? r.data.nbCustomers || '-' : '-'
        })
    }
  }
}
</script>

<style scoped lang="scss">
  @import "~@/scss/variables";

  #home {
    @media (min-width: $grid-breakpoint-xl) {
      max-width: 70vw;
    }
  }
</style>
